import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import { errorMiddleware } from 'middleware/errorMiddleware';
import rootSaga from 'sagas';
import rootReducer from './reducers';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware, errorMiddleware))
);

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept('./reducers', () => {
    /* eslint-disable-next-line global-require */
    store.replaceReducer(require('./reducers').default);
  });
}
sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
